import { Link } from 'react-router-dom';
import { useLocale } from '../../application/i18n/LocaleProvider';
import { selectCompanions } from '../../domain/plants/plantCompanions';
import { bandSrcSet } from '../../domain/plants/plantMedia';
import { ChevronRightIcon, CommunityIcon } from '../chrome/BrandIcons';

/**
 * "Perfect companions" — plants that want the same conditions as this one
 * (SPEC-003 D-5). Derived, because no content pack names a companion.
 *
 * A horizontal rail rather than a grid: the reference clips the fourth card at
 * the screen edge, which is the affordance that says there is more sideways.
 */
export default function CompanionRail({ plant, plants }) {
    const { t, localeCode, languageCode } = useLocale();
    const companions = selectCompanions(plants, plant, { languageCode });

    if (!companions.length) {
        return null;
    }

    return (
        <section className="companions">
            <div className="companions__head">
                <CommunityIcon size={26} />
                <h2 className="companions__title">{t('plants.detail.companions')}</h2>
                <Link className="companions__see-all" to={`/${localeCode}/plants`}>
                    {t('plants.detail.seeAll')}
                    <ChevronRightIcon size={20} />
                </Link>
            </div>
            <ul className="companions__rail">
                {companions.map((companion) => {
                    const { illustrationBase, illustrationWidths } = companion.media;

                    return (
                        <li className="companion" key={companion.id}>
                            <Link
                                className="companion__link"
                                to={`/${localeCode}/plants/${companion.id}`}
                                style={{ '--plant-wash': `var(--wash-${companion.wash})` }}
                            >
                                <span className="companion__tile">
                                    <img
                                        className="companion__art"
                                        src={`${illustrationBase}-${illustrationWidths[0]}.webp`}
                                        srcSet={bandSrcSet(illustrationBase, illustrationWidths)}
                                        sizes="160px"
                                        // The name below the card says which plant
                                        // this is; the illustration would only say
                                        // it twice.
                                        alt=""
                                        loading="lazy"
                                        decoding="async"
                                        width="400"
                                        height="500"
                                    />
                                </span>
                                <p className="companion__name">
                                    {companion.prose?.commonName ?? companion.id}
                                </p>
                                <p className="companion__botanical">{companion.botanicalName}</p>
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </section>
    );
}
